import Vue from 'vue';
import Router from 'vue-router';

// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');

// Menu -> Clients
const GestionClients = () => import('@/views/pages/clients/ClientsGestion');
const ClientModifier = () => import('@/views/pages/clients/ClientModifier');

// Menu -> Commande
const PackageList = () => import('@/views/pages/orders/packages/PackageList');
const TicketList = () => import('@/views/pages/orders/customer-service/ticket-list');
const CreateTicket = () => import('@/views/pages/orders/customer-service/create-ticket');
const EditTicket = () => import('@/views/pages/orders/customer-service/edit-ticket');

// Menu -> Entrepôts
const Production = () => import('@/views/pages/warehouse/production/Production');
const GenerateLabels = () => import('@/views/pages/warehouse/labels/GenerateLabels');
const MovePackages = () => import('@/views/pages/warehouse/MovePackages');
const ProductionSummary = () => import('@/views/pages/warehouse/production_summary/ProductionSummary');
const BlockedPackageList = () => import('@/views/pages/warehouse/block_package/BlockedPackageList');

// Menu -> Colikado
const FlightList = () => import('@/views/pages/aerial/transport/FlightList');
const PalletList = () => import('@/views/pages/aerial/transport/pallets/PalletList');

// Menu -> Administration
const ComplaintReasonList = () => import('@/views/pages/administration/complaint-reason/ComplaintReasonList');

Vue.use(Router);

export default new Router({
	mode: 'hash', // https://router.vuejs.org/api/#mode
	linkActiveClass: 'active',
	scrollBehavior: () => ({ y: 0 }),
	routes: configRoutes(),
});

function configRoutes() {
	return [
		{
			path: '/',
			redirect: '/dashboard',
			name: 'Home',
			meta: {
				auth: true,
			},
			component: TheContainer,
			children: [
				{
					path: 'dashboard',
					name: 'Dashboard',
					component: Dashboard,
				},

				/** CLIENTS */
				{
					path: '/clients',
					meta: { label: 'Clients' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: '', // parent's url
							component: GestionClients,
						},
						{
							path: 'gestion-clients',
							name: 'Gestion des clients',
							component: GestionClients,
						},
						{
							path: ':id?/edit',
							name: 'Edition',
							component: ClientModifier,
						},
					],
				},
				/** COMMANDES */
				{
					path: '/orders',
					meta: { label: 'Commandes' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'list',
							name: 'Gestion des commandes',
							component: () => import('@/views/pages/orders/orders/OrdersList'),
						},
						{
							path: 'new',
							name: "Création d'une commande",
							component: () => import('@/views/pages/orders/orders/create-order'),
						},
						{
							path: ':id?/edit',
							name: "Edition d'une commande",
							component: () => import('@/views/pages/orders/orders/edit-order'),
						},
						{
							path: ':id?/cb-payment-verify',
							name: 'Vérification du paiement',
							component: () => import('@/views/pages/orders/orders/cb-payment-verify'),
						},
						{
							path: 'customer-service/tickets',
							name: 'Gestion tickets de support',
							component: TicketList,
						},
						{
							path: 'customer-service/tickets/new',
							name: "Création d'un ticket",
							component: CreateTicket,
						},
						{
							path: 'customer-service/tickets/:id?/edit',
							name: "Edition d'un ticket",
							component: EditTicket,
						},
						{
							path: 'packages',
							name: 'Liste des colis',
							component: PackageList,
						},
						{
							path: 'payments-history/list',
							name: 'Historique des caisses',
							component: () => import('@/views/pages/orders/payments-history/list'),
						},
					],
				},

				/** ENTREPÔT */
				{
					path: '/warehouse',
					meta: { label: 'Entrepot' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'blocked-packages',
							name: 'Gestion des colis bloqués',
							component: BlockedPackageList,
						},
						{
							path: 'production',
							name: 'Production',
							component: Production,
						},
						{
							path: 'generate-labels',
							name: 'Generate labels',
							component: GenerateLabels,
						},
						{
							path: 'move-packages',
							name: 'Move packages',
							component: MovePackages,
						},
					],
				},

				/** AERIAL */
				{
					path: '/aerial',
					meta: { label: 'Aérienne' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'flights',
							name: 'Vols',
							component: FlightList,
						},
						{
							path: 'pallets',
							name: 'Pallets',
							component: PalletList,
						},
					],
				},

				/** MANIFESTES */
				{
					path: 'manifest',
					meta: { label: 'Manifestes' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'shop-notify-customer',
							name: 'SHIPNOTCUS',
							component: () =>
								import(
									'@/views/pages/manifest/shop-notify-customer/shop-notify-customer.vue'
								),
						},
						{
							path: 'aerial',
							name: 'Sûreté aérienne',
							component: () => import('@/views/pages/manifest/aerial/aerial.vue'),
						},
					],
				},

				/** POINTS OF SALE */
				{
					path: 'points-of-sale',
					meta: { label: 'Points de vente' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'management',
							name: 'Gestion des points de vente',
							component: () => import('@/views/pages/points-of-sale/management.vue'),
						},
						{
							path: 'history',
							name: 'Historique facturation',
							component: () => import('@/views/pages/points-of-sale/history/history.vue'),
						},
						{
							path: 'history/credit-notes/:id',
							name: 'Liste des corrections',
							component: () =>
								import('@/views/pages/points-of-sale/history/credit-notes/credit-notes.vue'),
						},
					],
				},

				/** PICKUP POINTS */
				{
					path: 'pick-up-points',
					meta: { label: 'Points de retrait' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'packages-listing',
							name: 'Listing des colis des points retrait',
							component: () => import('@/views/pages/pick-up-points/packages-listing.vue'),
						},
						{
							path: 'list',
							name: 'Gestion des points de retrait',
							component: () => import('@/views/pages/pick-up-points/pickup-points-list'),
						},
					],
				},

				/** SLIPS */
				{
					path: 'slips',
					meta: { label: 'Bordereaux' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'link-point-of-sale',
							name: 'Lier à un point de vente 1/2',
							component: () => import('@/views/pages/slips/link-point-of-sale.vue'),
						},
						{
							path: 'link-point-of-sale/:id',
							name: 'Lier à un point de vente 2/2',
							component: () => import('@/views/pages/slips/link-point-of-sale-step-2.vue'),
						},
						{
							path: 'receive',
							name: 'Réceptionner un bordereau',
							component: () => import('@/views/pages/slips/receive.vue'),
						},
						{
							path: 'history',
							name: 'Historique des liaisons',
							component: () => import('@/views/pages/slips/history.vue'),
						},
						{
							path: 'remove',
							name: 'Retirer un bordereau',
							component: () => import('@/views/pages/slips/remove.vue'),
						},
					],
				},

				/** CARRIERS */
				{
					path: 'carriers',
					meta: { label: 'Transporteurs' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'management',
							name: 'Gestion des transporteurs',
							component: () => import('@/views/pages/carriers/management.vue'),
						},
					],
				},

				/** Catalog */
				{
					path: 'catalog',
					meta: { label: 'Catalogue' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'products',
							name: 'Gestion des produits',
							component: () => import('@/views/pages/catalog/products/management.vue'),
						},
					],
				},

				/** ADMINISTRATION */
				{
					path: '/administration',
					meta: { label: 'Administration' },
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: 'raisons-litige',
							name: 'Raison litiges',
							component: ComplaintReasonList,
						},
					],
				},
			],
		},
		{
			path: '/pages',
			redirect: '/pages/404',
			name: 'Pages',
			component: {
				render(c) {
					return c('router-view');
				},
			},
			children: [
				{
					path: '404',
					name: 'Page404',
					component: Page404,
				},
				{
					path: '500',
					name: 'Page500',
					component: Page500,
				},
				{
					path: 'login',
					name: 'Login',
					component: Login,
				},
			],
		},
	];
}
